import Immutable from 'immutable';

export interface RawStudioImportRequest {
  id: number;
  fileName: string;
  filePath: string;
  fileSize: number;
  studioprojectid: string;
}

export interface StudioImportRequestData {
  id: number;
  fileName: string;
  filePath: string;
  fileSize: number;
  studioprojectid: string;
}

const defaultValues: StudioImportRequestData = {
  id: 0,
  fileName: '',
  filePath: '',
  fileSize: 0,
  studioprojectid: '',
};

export const StudioImportRequestFactory = Immutable.Record(
  defaultValues,
  'StudioImportRequest'
);

export class StudioImportRequest extends StudioImportRequestFactory {
  static deserialize(
    rawStudioImportRequest: StudioImportRequestData
  ): StudioImportRequestData {
    return new StudioImportRequest({ ...rawStudioImportRequest });
  }

  serialize(): RawStudioImportRequest {
    return this.toJS();
  }
}

export type StudioImportRequestList = Immutable.List<StudioImportRequest>;
